import produce from 'immer';

import * as actions from './actions';

export const initialState = {
  guardianContacts: { data: null, loading: false, error: null },
};

const reducer = (state = initialState, action) => produce(state, (draft) => {
  switch (action.type) {
    case actions.FETCH_GUARDIAN_CONTACTS_BY_USER_REQUEST:
      draft.guardianContacts.loading = true;
      break;
    case actions.FETCH_GUARDIAN_CONTACTS_BY_USER_SUCCESS:
      draft.guardianContacts.loading = false;
      draft.guardianContacts.data = action.payload.guardianContacts;
      break;
    case actions.FETCH_GUARDIAN_CONTACTS_BY_USER_FAILURE:
      draft.guardianContacts.loading = false;
      draft.guardianContacts.error = action.payload.error;
      break;
    default:
  }
});

export default reducer;
